import React from "react"
import PropTypes from "prop-types"
import { P } from "../../typography"
import Button from "../../button"
import { Container } from "./styles"

const Columnsets = ({ columnsets, selected, setSelected }) => {
  const handleClick = (event, { name }) => {
    event.preventDefault()
    if (setSelected !== undefined) setSelected(name)
  }

  const checkSelected = ({ name }) => name === selected

  return (
    <Container>
      {columnsets.length > 0 && (
        <>
          <P variant="secondary" bold marginless>
            View:
          </P>
          {columnsets.map((columnset) => (
            <Button
              size="small"
              variant={!!checkSelected(columnset) ? "primary" : "secondary"}
              onClick={(event) => handleClick(event, columnset)}
            >
              {columnset.title}
            </Button>
          ))}
        </>
      )}
    </Container>
  )
}

Columnsets.propTypes = {
  columnsets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string
    })
  ),
  selected: PropTypes.string,
  setSelected: PropTypes.func
}

Columnsets.defaultProps = {
  columnsets: [],
  selected: "",
  setSelected: undefined
}

export default Columnsets
